import React, { useEffect, useMemo, useRef, useState } from 'react';
import AppLayout from '../../layout/AppLayout';
import styles from './index.module.scss';
import SearchAnimated from '../../components/SearchAnimated';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import AllBrand from './components/AllBrand';
import { useAllOffers } from '../../api/api.calls';
import { get } from 'lodash';
import { useIdHash, useNavigateRoute } from '../../hooks/custom.hooks';

function BrandPage() {
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const { selected = [] } = useIdHash();
  const [searchedValue, setSearchedValue] = useState('');
  const { data: apiResponse } = useAllOffers();
  const allBrands = useMemo(
    () => get(apiResponse, 'filters', {}),
    [apiResponse],
  );
  const { brand } = allBrands;
  const hasNonEmptyArray = useMemo(
    () => Object.keys(brand || {}).some((key) => (brand[key] || []).length > 0),
    [brand],
  );
  const searchRef = useRef();

  useOnClickOutside(searchRef, () => {
    if (searchedValue.length === 0) {
      setIsSearchFocused(false);
    }
  });

  useEffect(() => {
    if (selected) {
      setIsSearchFocused(true);
    }
  }, [selected]);

  const navigateRoute = useNavigateRoute();
  return (
    <AppLayout
      showLogo={true}
      gobackAction={() => {
        navigateRoute({ goBack: true });
      }}
      customHeader={() => {
        return (
          <div className={styles.offerHeader}>
            {!isSearchFocused && <div className={styles.left}>All Brands</div>}
            {hasNonEmptyArray && (
              <div
                className={`${styles.right} ${isSearchFocused ? styles.focused : ''}`}
                ref={searchRef}
              >
                <SearchAnimated
                  placeholder={isSearchFocused ? 'Type brand name' : 'Search'}
                  onChange={(value) => setSearchedValue(value)}
                  isSearchFocused={isSearchFocused}
                  setIsSearchFocused={setIsSearchFocused}
                  value={searchedValue}
                />
              </div>
            )}
          </div>
        );
      }}
    >
      <AllBrand
        brand={brand}
        searchedValue={searchedValue}
        setSearchedValue={setSearchedValue}
        setIsSearchFocused={setIsSearchFocused}
      />
    </AppLayout>
  );
}

export default BrandPage;
